import AlphaFilters from '@nematis/wp-alpha/assets/js/abstracts/classes/alpha-filters'

// The event planner app lives in the child theme: skip the parent's dynamic chunk import.
AlphaFilters.addFilter('load.petiteVue.apps', (importer, appFileName) => {
  if (appFileName === 'event-planner') {
    return () => Promise.resolve()
  }

  return importer
}, 'child')

// State & methods of the "Votre événement en deux questions" widget (HP privatisation section).
// The salles list and initial state come from the embedded app data (PHP side).
AlphaFilters.addFilter('app.petiteVue.data', (data, appName) => {
  if (appName !== 'eventPlanner') {
    return data
  }

  return Object.assign({
    event: 'Mariage',
    pax: 60,
    salles: []
  }, data, {
    isEvent(type) {
      return this.event === type
    },
    setEvent(type) {
      this.event = type
    },
    setPax(event) {
      this.pax = Number(event.target.value)
    },
    eventName() {
      return this.event.toLowerCase()
    },
    currentSalle() {
      const salles = this.salles || []

      return salles.find((salle) => this.pax <= salle.max) || salles[salles.length - 1] || {}
    },
    salleName() {
      return this.currentSalle().name || ''
    },
    salleLine() {
      return this.currentSalle().line || ''
    }
  })
}, 'child')
